import { render, staticRenderFns } from "./Business.vue?vue&type=template&id=3e03a8c3&scoped=true"
import script from "./Business.vue?vue&type=script&lang=ts"
export * from "./Business.vue?vue&type=script&lang=ts"
import style0 from "./Business.vue?vue&type=style&index=0&id=3e03a8c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e03a8c3",
  null
  
)

export default component.exports